export default __webpack_public_path__ + "static/aquanet-846a48745c583342ffd9902f7303f88a.png";